import comp from "./Step1.js";
export default comp;
